export default __webpack_public_path__ + "static/media/customer-profile.ef6682f0.png";